<template>
  <v-autocomplete
    color="primary"
    v-model="alliancesSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="alliancesItems"
    :loading="alliancesLoading"
    :search-input.sync="alliancesSearch"
    item-text="Description"
    item-value="alliance_business_id"
    :label="noLabel ? '' : $consts.allianceName()"
    return-object
  ></v-autocomplete>
</template>

<script>
import AllianceBusinesses from "@/api/alliance_businesses";

export default {
  name: "SearcherAlliances",

  props: { value: Array, noLabel: Boolean },

  computed: {
    alliancesItems() {
      return this.alliances.map((alliance) => {
        const Description =
          alliance.alliance_business_code +
          " / " +
          alliance.alliance_business_name;
        return Object.assign({}, alliance, { Description });
      });
    },
  },

  data: () => ({
    alliances: [],
    alliancesLoading: false,
    alliancesSearch: "",
    alliancesSelected: [],
  }),

  mounted() {
    this.alliancesLoading = true;
    AllianceBusinesses.fetchAllForSelect({})
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.alliances = response.data.alliance_businesses;
          }
          this.alliancesLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.alliancesLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.alliancesSelected = this.value;
      },
    },
    alliancesSelected: {
      handler() {
        this.$emit("input", this.alliancesSelected);
      },
    },
  },
};
</script>
